/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';

export const getTalonOneRewardsState = (state) => state.member?.talonOneRewards || {};

export const getTalonOneRewardsData = (state) => state.member?.talonOneRewards?.data || null;

export const getTalonOneRewardsLoading = (state) => state.member?.talonOneRewards?.isLoading || false;

export const getTalonOneRewardsError = (state) => state.member?.talonOneRewards?.isError || false;

/**
 * Get the current balance from TalonOne rewards
 * Returns the loyalty program's current balance or 0 if not available
 */
export const getTalonOneCurrentBalance = createSelector(
    [getTalonOneRewardsData],
    (rewardsData) => {
        const rawBalance = rewardsData?.loyalty?.programs?.Customer_Rewards?.ledger?.currentBalance;
        if (typeof rawBalance === 'number' && !Number.isNaN(rawBalance)) {
            return rawBalance;
        }
        return Number(rawBalance) || 0;
    },
);
